import templateUrl from "./identity-claims-list.component.html";

const apexClaimDescriptions = [
    { type: "apex:SuperUser", name: "Super User", value: "true", description: "Granting this claim gives implicit full site access" },
    { type: "apex:HubAtIcdCorporation", name: "Hub", description: "Claim granted to users automatically when they are assigned as an ICD hub." },
    { type: "apex:AuditorAtIcdCorporation", name: "SC Auditor", description: "Claim granted to users automatically when they are assigned as an ICD auditor." },
    { type: "apex:NationalConsultantAtIcdOffice", name: "National Consultant", description: "Claim granted to users automatically when they are assigned as an office NC." },
    { type: "apex:RegionalConsultantAtIcdOffice", name: "Regional Consultant", description: "Claim granted to users automatically when they are assigned as an office RC." },
    { type: "apex:PromotingOwnerAtIcdOffice", name: "Promoting Owner", description: "Claim granted to users automatically when they are assigned as an office PO." },
    {
        type: "apex:OfficeRoleAtOffice",
        name: "Role assignment scoped to an office",
        description: "Claim granted to users who were assigned a role at a particular office."
            + "The claim value format is the (RoleID, IcdOfficeID) pair."
    },
    {
        type: "apex:DivisionRoleAtDivision",
        name: "Role assignment scoped to a division",
        description: "Claim granted to users who were assigned a role at a particular division."
            + "The claim value format is the (RoleID, DivisionID) pair."
    },
    {
        type: "apex:OnRosterAtOffice",
        name: "On the Roster",
        description: "Claim granted to users are on the roster at an office."
    },
    {
        type: "apex:RoleDelegator",
        name: "Role Delegator",
        description: "Claim designating the user as having the ability to assign other users to a role. "
            + "The claim value will be the RoleID of the role that can be assigned. Enter ALL to delegate any role."
    },
    {
        type: "apex:TimeClockForOffice",
        name: "Time Clock",
        description: "Claim stating that the user is on the time clock and can enter their own time."
    },
    {
        type: "apex:SelfSignUpApplicant",
        name: "Self-Sign-Up Applicant",
        description: "Claim stating that the user is self-onboarding and can fill in or submit their application."
    },
    {
        type: "apex:TeamMember",
        name: "Team Member",
        description: "Claim granted automatically when a user is a member of a team. Enter a TeamID to give "
            + "specific teams access to special permissions."
    },
    {
        type: "apex:TeamLeader",
        name: "Team Leader",
        description: "Claim granted automatically when a user is a leader of a team. This can be used to give"
            + " extra permissions to the team leader of specific teams."
    }
]

export const IdentityClaimsListComponent = {
    templateUrl,
    controller: class {
        constructor($state) {
            'ngInject';
            this.$state = $state;
            this.apexClaimTypes = apexClaimDescriptions;
        }

        editClaimPermissions(claim) {
            this.$state.go("admin.claim.edit", {
                claimType: btoa(claim.type),
                claimValue: claim.value || ""
            });
        }
    }
}
